const cityMap = new Map()
cityMap.set("75101", "Paris")
cityMap.set("06088", "Nice")
cityMap.set("69381", "Lyon")
cityMap.set("59350", "Lille")
cityMap.set("33063", "Bordeaux")

export default cityMap